export var MuiChipOverrides = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '18px' /* 138.462% */,
      letterSpacing: '0.16px',
      height: 'auto',
      '& > span:first-of-type': {
        padding: '4px 12px'
      },
      width: 'auto'
    },
    deletable: {
      '& > span:first-of-type': {
        paddingRight: '6px'
      }
    },
    sizeMedium: {
      '& > span:first-of-type': {
        padding: '7px 12px'
      }
    },
    outlined: {
      borderColor: 'currentcolor'
    },
    icon: {
      fontSize: '1rem'
    },
    avatarSmall: {
      height: '1.25rem',
      width: '1.25rem',
      marginLeft: '4px'
    },
    avatarMedium: {
      height: '1.5rem',
      width: '1.5rem'
    },
    deleteIcon: {
      fontSize: '1rem',
      marginRight: 6,
      marginLeft: 0
    }
  }
};